var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('v-container',_vm._b({class:[!_vm.showBreadcrumbs && 'pt-3']},'v-container',_vm.containerConfig,false),[_c('i4proBreadcrumbs'),_c(_vm.component,{tag:"component",attrs:{"page":_vm.dataPage,"context":_vm.dataMode}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }